// @flow

import { RESORT_SUMMARY } from 'Client/cms/toolkit/constants';
import { ProductSummaryLine } from 'Components/lines/product-summary-line/ProductSummaryLine';
import { productSummaryResolver } from './productSummary.resolver';

export const productSummaryDescriptor = {
  name: RESORT_SUMMARY,
  component: ProductSummaryLine,
  resolve: productSummaryResolver.resolve,
};
